class AlgoliaMixedStylesCardProduct extends HTMLElement {
  constructor() {
    super();

    this.connectedCallback = this.connectedCallback.bind(this);
    this.getStyle = this.getStyle.bind(this);
    this.render = this.render.bind(this);
  }

  /**
    * Initializes settings based on custom attributes when the element is connected to the DOM.
    * @returns {void}
    */
  connectedCallback() {
    this.settings = {
      class: this.getAttribute('class'),
      layout: this.getAttribute('layout'),
      style: this.getAttribute('style'),
      width: this.getAttribute('width')
    }
  }

  /**
   * Returns the CSS styles.
   * @returns {string} The CSS style block as a string.
   */
  getStyle() {
    const style = document.createElement('style');
    const css = `
      .aa-Item .container,
      .container {
        display: grid;
        gap: 4px;
        grid-template-columns: repeat(var(--number-of-columns), 1fr);
      }
    `;
    style.appendChild(document.createTextNode(css));
    return style;
  }

  /**
   * Renders the mixed styles card product content.
   * @returns {string} The rendered mixed styles card product.
   */
  render(colorCode, parentSku) {
    const style = this.getStyle();

    const mixedStylesCardProduct = document.createElement('mixed-styles-card-product');
    mixedStylesCardProduct.className = this.settings.class;
    mixedStylesCardProduct.setAttribute('color-code', colorCode);
    mixedStylesCardProduct.setAttribute('fallback-width-on-fail', 'true');
    mixedStylesCardProduct.setAttribute('layout', this.settings.layout);
    mixedStylesCardProduct.setAttribute('parent-sku', parentSku);
    mixedStylesCardProduct.setAttribute('style', this.settings.style);
    mixedStylesCardProduct.setAttribute('width', this.settings.width);

    const container = document.createElement('div');
    container.className = 'container';
    mixedStylesCardProduct.appendChild(container);

    return [style, mixedStylesCardProduct];
  }
}

customElements.define("algolia-mixed-styles-card-product", AlgoliaMixedStylesCardProduct);